import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

type ConceptOption = { value: string; label: string };

export async function getConceptsByType(
  type: string,
): Promise<ConceptOption[]> {
  const json = await smartFetch(
    `${API_URL}/private/concepts/formatted?t=${type}`,
    {
      method: "GET",
    },
  );

  return json as ConceptOption[];
}

export async function getConceptsByParent(
  type: string,
): Promise<ConceptOption[]> {
  const json = await smartFetch(
    `${API_URL}/private/concepts/children?p=${type}&t=deliverable`,
    {
      method: "GET",
    },
  );

  return json as ConceptOption[];
}

export async function getBrands(): Promise<string[]> {
  const json = await smartFetch(`${API_URL}/private/my-network/brands`, {
    method: "GET",
  });

  return json as string[];
}
